<template>
  <div class="invechild-content">
    <div class="content-item" v-for="(item, index) in detailList" :key="index">
      <div class="item-title">
        <div class="title">{{ item.areaTripCaseVO ? item.areaTripCaseVO.caseTypeCN : "" }}</div>
      </div>
      <div class="item-content">
        <div class="cases-inve">
          <span class="name">案件级别：</span>
          <span
            class="text"
          >{{ item.areaTripCaseVO && item.areaTripCaseVO.caseLevel === "big" ? "涉旅案件" : "较大涉旅案件" }}</span>
        </div>
        <div class="cases-link-c">
          <span class="name-link">案件链接：</span>
          <div class="cases-link-content">
            <linkCom :hasDeleteBtn="false" v-model="item.websiteVOS"></linkCom>
          </div>
        </div>
        <div class="cases-material">
          <materialSciense title="相关材料" :caseList="item.fileResVOS"></materialSciense>
        </div>
        <div class="cases-remarks">
          <span class="remark-text">
            备
            <i class="jiange"></i>注：
          </span>
          <div class="has-text" v-if="item.areaTripCaseVO.caseDesc">
            <span>{{item.areaTripCaseVO.caseDesc}}</span>
          </div>
          <div class="has-text-no" v-else>无</div>
        </div>
      </div>
      <btnauth style="width: 100%" custype="apply" :year="year" :quarter="quarter">
        <div class="bottom-btn">
          <div
            class="left-btn"
            @click="deleteClick(index)"
            v-if="deleteAuth && deleteAuth === 'OPERATION03' && isSubmited == 0 && (userId === datauserId || !datauserId) "
          >
            <img class="deleteimg" :src="require('../../../../assets/appraise/delete.png')" />
            <span>删除</span>
          </div>
          <!-- </btnauth> -->
          <!-- <btnauth style="width: 100%"  custype="apply" :year="year" :quarter="quarter"> -->
          <div
            class="right-btn"
            v-if="updateAuth && updateAuth === 'OPERATION02' && isSubmited == 0 && (userId === datauserId || !datauserId) "
            @click="addbtnClick(item.areaTripCaseVO.batchCode)"
          >
            <img class="updateimg" :src="require('../../../../assets/appraise/update2.png')" />
            <span>编辑</span>
          </div>
        </div>
      </btnauth>
    </div>
    <div v-if="submitAuth && submitAuth === 'OPERATION04' && isSubmited == 0 &&  (userId === datauserId || !datauserId)  ">
      <cusBtn2 @click="isUpDataShow = true"></cusBtn2>
    </div>
    <deleteModal :isShow="isShow" @cancel="cancel" title="是否确定删除" okBtn="删除" @onOk="onOk"></deleteModal>

    <uploadModal
      :isShow="isUpDataShow"
      @cancel="isUpDataShow = false"
      :content="`您已添加${detailList.length}项查处情况， 是否确定上报`"
      @onOk="updataConfirm"
    ></uploadModal>
  </div>
</template>
<script>
import linkCom from "./linkCom";
import materialSciense from "./materialScience_detail";
import deleteModal from "./deleteModal";
import uploadModal from "./uploadModal";
import cusBtn2 from "./cusBtn2";
import btnauth from "./btnauth";
import commonAPI from "@/utils/common";
export default {
  name: "inveChilddetail",
  props: {
    detailList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    deleteAuth: {
      type: String,
      default: () => {
        return "";
      },
    },
    updateAuth: {
      type: String,
      default: () => {
        return "";
      },
    },
    submitAuth: {
      type: String,
      default: () => {
        return "";
      },
    },
    isSubmited: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    year: {
      type: [String, Number],
      default: () => {
        return "";
      },
    },
    quarter: {
      type: [String, Number],
      default: () => {
        return "";
      },
    },
    datauserId:{
      type: String,
      default:()=>{
        return "";
      }
    }
  },
  components: {
    linkCom,
    materialSciense,
    deleteModal,
    cusBtn2,
    uploadModal,
    btnauth,
  },
  data() {
    return {
      caseList: [],
      elementIndex: "",
      hasremark: false,
      isShow: false,
      isUpDataShow: false,
      userId: commonAPI.getUserId(),
    };
  },
  methods: {
    deleteClick(index) {
      this.isShow = !this.isShow;
      this.elementIndex = index;
    },
    cancel() {
      this.isShow = false;
    },
    /** 确认删除 **/
    onOk() {
      this.isShow = false;
      this.$emit("onDel", this.detailList[this.elementIndex]);
    },
    /** 跳转新增和编辑页面 **/
    addbtnClick(code) {
      this.$emit("addbtnClick", code);
    },
    /** 上报确认 **/
    updataConfirm() {
      this.isUpDataShow = false;
      this.$emit("updataConfirm");
    },
  },
};
</script>
<style lang="less" scoped>
.invechild-content {
  width: 100%;
  .content-item {
    width: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    margin-bottom: 12px;
    .item-title {
      // padding: 0 12px;
      width: 100%;
      position: relative;
      overflow: hidden;
      .title {
        margin-left: 12px;
        width: 100%;
        font-size: 14px;
        height: 40px;
        line-height: 40px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
    }
    .item-title::after {
      content: "";
      position: absolute;
      bottom: 1px;
      width: 100%;
      height: 1px;
      padding: 0;
      margin: 0 auto;
      background-color: #eeeeee;
      transform: scaleY(1);
    }
    .item-content {
      padding: 0 12px;
      .cases-inve {
        margin-top: 15px;
        margin-bottom: 16px;
        .name {
          width: 70px;
          height: 14px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 14px;
        }
        .text {
          width: 200px;
          height: 14px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 14px;
          margin-left: 4px;
        }
      }
      .cases-link-c {
        .name-link {
          width: 70px;
          height: 14px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 14px;
        }
        .cases-link-content {
          margin-top: 8px;
        }
      }
      // .cases-material {
      // }
      .cases-remarks {
        display: flex;
        margin-top: -2px;
        .remark-text {
          display: block;
          width: 70px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          margin-top: 2px;
          .jiange {
            margin-left: 22px;
          }
        }
        .has-text {
          flex: 1;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 18px;
          // text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          white-space: pre-wrap; /* 让过长的单词在必要时断开换行 */
          overflow-wrap: break-word; /* 让过长的单词在必要时断开换行 */
          span {
            margin: 0 auto;
          }
        }
        .has-text-no {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 18px;
        }
      }
    }
    .bottom-btn {
      width: 100%;
      height: 44px;
      position: relative;
      margin-top: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left-btn {
        width: 50%;
        height: 100%;
        display: flex;
        justify-content: center;
        position: relative;
        align-items: center;
        .deleteimg {
          width: 14px;
          height: 14px;
        }
        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(54, 179, 116, 1);
          margin-left: 4px;
        }
      }
      .left-btn::after {
        content: "";
        position: absolute;
        left: 100%;
        width: 1px;
        height: 100%;
        background-color: #eeeeee;
        transform: scaleX(0.5);
      }
      .right-btn {
        width: 50%;
        display: flex;
        height: 100%;
        justify-content: center;
        align-items: center;
        .updateimg {
          width: 14px;
          height: 14px;
        }
        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(54, 179, 116, 1);
          margin-left: 4px;
        }
      }
    }
    .bottom-btn::after {
      content: "";
      position: absolute;
      top: 0;
      width: 100%;
      height: 1px;
      margin: 0 auto;
      padding: 0;
      background-color: #eeeeee;
      transform: scaleY(0.5);
    }
  }
}
</style>
